import { Typography, Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
// import { getContactInfo } from "./utils"
import { MeetingDetailsOrder } from "../../../../../../nonAdminUser/reports/home/meetingServiceApi"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { getContactInfo } from "../slipModal/utils"

const useStyles = makeStyles()((theme) => ({
    contactSection: {
        marginTop: "1rem",
    },
    contactLabel: {
        width: "9rem",
        marginBottom: theme.spacing(0.5),
    },
    contactName: {
        fontWeight: 500,
        textAlign: "right",
        color: theme.palette.tailwind.slate[900],
    },
    contactInfo: {
        display: "flex",
        textAlign: "left",
        color: theme.palette.tailwind.slate[900],
    },
    sectionTitle: {
        fontWeight: 600,
        color: theme.palette.tailwind.slate[700],
        marginBottom: theme.spacing(2),
    },
    contactRow: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: theme.spacing(2),
    },
    contactEmailAndPhone: {
        color: theme.palette.tailwind.slate[900],
        fontWeight: 400,
    },
    phonePrefix: {
        marginLeft: "0.25rem",
        color: theme.palette.tailwind.slate[900],
        fontWeight: 500,
    },
}))

interface ContactDetailsProps {
    order: MeetingDetailsOrder
}

export default function ContactDetails({ order }: ContactDetailsProps) {
    const { classes } = useStyles()

    const { creator, meetingHost, showBoth } = getContactInfo(order.organizers)

    return (
        <Box className={classes.contactSection}>
            {showBoth && creator && (
                <Box className={classes.contactRow}>
                    <LocalizedStrict id="production-package-slip-section-contact-details-meeting-creator">
                        <Typography variant="body1" color="text.secondary" className={classes.contactLabel}>
                            Creator:
                        </Typography>
                    </LocalizedStrict>
                    <Box className={classes.contactInfo}>
                        <Typography variant="body1" className={classes.contactName}>
                            {creator.name}
                        </Typography>

                        {creator.phone && (
                            <Typography variant="body1" className={classes.contactEmailAndPhone}>
                                {creator.phone}
                            </Typography>
                        )}
                    </Box>
                </Box>
            )}

            {meetingHost && (
                <Box className={classes.contactRow}>
                    <LocalizedStrict id="production-package-slip-section-contact-details-meeting-host">
                        <Typography variant="body1" color="text.secondary" className={classes.contactLabel}>
                            Meeting host:
                        </Typography>
                    </LocalizedStrict>
                    <Box className={classes.contactInfo}>
                        <Typography variant="body1" className={classes.contactName}>
                            {meetingHost.name}
                        </Typography>
                        {meetingHost.phone && (
                            <Typography variant="body1" className={classes.contactEmailAndPhone}>
                                <span className={classes.phonePrefix}>T:</span> {meetingHost.phone}
                            </Typography>
                        )}
                    </Box>
                </Box>
            )}
        </Box>
    )
}
